import React, { Component } from 'react';
import { connect } from 'react-redux';


import TyroModalMessage from './TyroModalMessage';
import TyroModalQuestion from './TyroModalQuestion';
import TyroModalError from './TyroModalError';
import {
  TYRO_STATUS_MESSAGE,
  TYRO_STATUS_QUESTION,
  TYRO_STATUS_ERROR
} from '../../constants'; 


class TyroModalContent extends Component {
  render() {
    const { type, message, options } = this.props;

    return (
      <div className="content" style={{ paddingTop: 10, paddingBottom: 10 }}>
        {(type === TYRO_STATUS_MESSAGE) &&
          <TyroModalMessage message={message} />
        }
        {(type === TYRO_STATUS_QUESTION) &&
          <TyroModalQuestion message={message} options={options} />
        }
        {(type === TYRO_STATUS_ERROR) &&
          <TyroModalError message={message} />
        }
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { tyro: { status } = {} } = state;
  const { type, message = "", options = [] } = status || {};

  return {
    type,
    options,
    message
  };
}


export default connect(mapStateToProps, null)(TyroModalContent);